import React, { FC } from 'react';
import { NotFoundImage } from '@app/icons';
import Button from '@/components/ui/Button';

interface NoTransactionsProps {
  clearAllFilters?: () => void;
  hasFilters?: boolean;
}

const NoTransactions: FC<NoTransactionsProps> = ({
  clearAllFilters,
  hasFilters,
}) => {
  const title = hasFilters ? 'No transactions found' : 'No transactions.';
  const text = hasFilters
    ? 'No results match your current filters or search terms. Try adjusting them to see more transactions.'
    : 'There are currently no transactions.';

  return (
    <div className="flex flex-col gap-4 items-center w-full py-8">
      <div>
        <NotFoundImage />
      </div>
      <div className="text-h6 text-navy-700 mt-2">{title}</div>
      <div className="text-body2 text-navy-600 text-center max-w-lg">
        {text}
      </div>
      {hasFilters && (
        <Button
          label="Clear filters"
          variant="primary"
          onClick={clearAllFilters}
        />
      )}
    </div>
  );
};

export default NoTransactions;
